import React, { useCallback, useEffect, useRef } from "react";
import { Route,  useNavigate, Routes } from 'react-router-dom';
import MarketReportLanding from "../../marketReportLanding/MarketReportLanding";
import MarketReportTable from "../../marketReportTable/MarketReportTable";
import Header from '../header/Header';
import { ENVIRONMENTS } from "../../../app.constant";

const RoutingManager = (): JSX.Element => {
    const navigation = useNavigate();
    const APP_ENVIRONMENT = process.env.REACT_APP_SE_APP_ENV;
    const INSIGHT_EDGE_URL = process.env.REACT_APP_INSIGHT_EDGE_URL;
    const mr_url = process.env.REACT_APP_MR_APP_URL;
    let isRequestFromTeamsApp = useRef(false); // This has used as a flag to exempt the route behavior from redirecting to Competitive Edge app store

    useEffect(() => {
      if(new URLSearchParams(window.location.search).get("source") === "teams"){
        isRequestFromTeamsApp.current = true;
        navigation("/");
      }
      // Sector Trend Download Report will have references to market report files in MR app. Below is checking the click is coming from sta pptx   
      if(new URLSearchParams(window.location.search).get("source") === "sta"){
          isRequestFromTeamsApp.current = true; // Common flag is set to exempt the route behaviour
          const filename = new URLSearchParams(window.location.search).get("filename") || '';
          navigation("/market-report", { state: { filename } });
        }

    },[]);
  
    useEffect(() => {
      if (
        APP_ENVIRONMENT === ENVIRONMENTS.LOCAL &&
        window.location.pathname === "/" &&
        window.location.search === ""
      )
        return;
      else if (
        APP_ENVIRONMENT !== ENVIRONMENTS.LOCAL &&
        (window.opener || (!window.opener &&
        isRequestFromTeamsApp.current))
      )
        return;
      else if (
        APP_ENVIRONMENT !== ENVIRONMENTS.LOCAL &&
        !window.opener && 
        !isRequestFromTeamsApp.current
      ) {
        window.open(INSIGHT_EDGE_URL, "_self");
      }
    });

    return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<MarketReportLanding />} />
        <Route path="/market-report" element={<MarketReportTable />} />
      </Routes>
    </div>
    );
};

export default RoutingManager;
